<template>
  <div>
  <el-row v-for="n in 4"
          :key="n">
    <el-col :span="6" v-for="o in getListPaging(n)" :key="o.advertisement_seq" :style="{ padding: '10px 15px' }">
      <el-card :body-style="{ padding: '0px', border:' 3px solid ' + o.color }">
        <div class="text-center">
          <img v-bind:src="'/api/common/media/' + o.advertisement_seq" style="height: 120px" @click="editRow(o)" />
        </div>
        <div>
          <div style="padding-left: 10px; padding-right: 10px; border-width: 1px 1px 0px 1px; border-style: solid; line-height: 14px; font-size: 10px;">
            <el-row>
              <el-col :span="8">{{o.position_number + o.position_code}}</el-col>
              <el-col :span="16" style="border-width: 0px 0px 0px 1px; border-style: solid;" class="text-right">{{o.width}} x {{o.height}}</el-col>
            </el-row>
          </div>
          <div style="padding-left: 10px; padding-right: 10px; border-width: 1px 1px 0px 1px; border-style: solid; line-height: 14px; font-size: 10px;">
            <el-row>
              <el-col :span="8">{{o.in_out}}</el-col>
              <el-col :span="8" class="text-center" style="border-width: 0px 1px 0px 1px; border-style: solid;">{{o.profit_text}}</el-col>
              <el-col :span="8" class="text-right">{{ getIsLight(o.is_light) }}</el-col>
            </el-row>
          </div>
          <div style="padding-left: 10px; padding-right: 10px; border-width: 1px 1px 0px 1px; border-style: solid; line-height: 14px; font-size: 10px;">
            <span style="overflow: hidden">{{o.company_name}}</span>
          </div>
          <div style="padding-left: 10px; padding-right: 10px; border-width: 1px 1px 1px 1px; border-style: solid; line-height: 14px; font-size: 10px;">
            <span style="overflow: hidden">{{o.goods_name}}</span>
          </div>
        </div>
      </el-card>
    </el-col>
  </el-row>
  <el-row>
    <el-col :span="24" align="center" style="height: 40px">
      <el-pagination
        :page-size="12"
        layout="prev, pager, next"
        :current-page.sync="currentPage"
        @current-change="handleCurrentChange"
        :total="list.length">
      </el-pagination>
    </el-col>
  </el-row>
  </div>
</template>

<script>
    import Vue from 'vue'
    import {Card, Row, Col, Pagination} from 'element-ui'
    import ColumnSettingProxy from "@/proxies/ColumnSettingProxy";
    import StoreProxy from "@/proxies/StoreProxy";
    import OrderProxy from "@/proxies/OrderProxy";
    import AdvertiserProxy from "@/proxies/AdvertiserProxy";
    import VueMoment from 'vue-moment'
    import vueNumeralFilterInstaller from 'vue-numeral-filter';

    Vue.use(vueNumeralFilterInstaller)
    Vue.use(VueMoment)
    Vue.use(Card)
    Vue.use(Row)
    Vue.use(Col)
    Vue.use(Pagination)

    export default {
        name: "AdvertisementPrintComponent",
        created: function () {
            this.findAllByUserIdAndPageType(this.pageType);
            if (this.pageType === "orderManagement") {
                this.getOrderList();
            }
        },
        props: {
            pageType: String,
        },
        computed: {
            getListPaging() {
                return (n) => this.list.filter(function (item) {
                    let next = (n - 1) * 4;
                    let start = ((this.currentPage - 1) * 12) + next;
                    let end = start + (n < 4 ? 4 : 0);
                    return item.num > start && item.num <= end;
                }, {currentPage : this.currentPage, n : n});
            }
        },
        methods: {
            tableRowStyle() {
                return this.$store.state.common.tableHeaderFont10CellStyle;
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            isHiddenColumn(column) {
                return this.columns.filter(function (c) {
                    return c.id === column && c.show;
                }).length > 0;
            },
            getList(param) {
                // 상세화면에서 돌아올때 리스트를 다시 검색하는 함 (검색 파라메타를 기억하고 있다고 재사용)
                if(param !== null) {
                    this.param = param;
                }
                if(this.param !== null) {
                    if (this.pageType === "storeStatus") {
                        this.currentPage = 1;
                        this.getStoreMediaList(this.param);
                    } else if (this.pageType === "orderManagement") {
                        this.getOrderList(this.param);
                    } else if (this.pageType === "advertisement") {
                        this.getAdvertiserMediaList(this.param);
                    }
                }
            },
            getStoreMediaList(param) {
                new StoreProxy(param)
                    .getStoreMediaList(param.storeSeq, param.storeFloorSeq)
                    .then((response) => {
                        this.list = response.medias;
                    });
            },
            getOrderList(param) {
                new OrderProxy()
                    .all()
                    .then((response) => {
                        this.list = response.orders;
                    });
            },
            getAdvertiserMediaList(param) {
                new AdvertiserProxy()
                    .getAdvertiserMediaList(param)
                    .then((response) => {
                        this.list = response.medias;
                    });
            },
            // 컬럼설정 조회
            findAllByUserIdAndPageType(pageType) {
                this.isShowTable = false;
                new ColumnSettingProxy()
                    .findAllByUserIdAndPageType(pageType)
                    .then((response) => {
                        this.columns = response.columnSettings;
                        this.isShowTable = true;
                    })
            },
            // 광고 상세 조회
            editRow(row) {
                this.$emit('editRow', row);
            },
            getMultipleSelections() {
                return this.multipleSelection;
            },
            resetList() {
                this.list = [];
                this.currentPage = 1;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
            },
            getListSize() {
                return this.list.length;
            },
            getIsLight(isLight) {
              return Vue.getIsLight(isLight);
            },
        },
        data() {
            return {
                columns: [],
                multipleSelection: [],
                list: [],
                isShowTable: true,
                param: null,
                currentPage: 1,
            }
        },
    }
</script>

<style scoped>
  .time {
    font-size: 13px;
    color: #999;
  }

  .bottom {
    padding-top: 13px;
    line-height: 12px;
  }

  .goods {
    height: 20px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }
</style>
